import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43deb08c&"
import script from "./favorite.js?vue&type=script&lang=js&"
export * from "./favorite.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports